import type { SVGProps } from "react";
export interface SyringeIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function SyringeIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: SyringeIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M3.705 18.705a1.125 1.125 0 1 1 1.59 1.59l-2.5 2.5a1.125 1.125 0 1 1-1.59-1.59zm14.499-17.5a1.126 1.126 0 0 1 1.506-.078l.085.078 3 3 .077.085a1.125 1.125 0 0 1-1.582 1.583l-.086-.078-.705-.704-2.204 2.204a1.125 1.125 0 0 1-1.591-1.59L18.908 3.5l-.704-.705-.076-.085a1.125 1.125 0 0 1 .076-1.505"
      />
      <path
        fill={color}
        d="M13.204 2.205a1.125 1.125 0 0 1 1.506-.078l.085.078 7 7 .077.085a1.125 1.125 0 0 1-1.582 1.582l-.085-.076L20 10.59 9.796 20.795c-.33.33-.805.52-1.19.63-.43.123-.941.2-1.48.2-1.068 0-2.396-.304-3.421-1.33-1.026-1.025-1.33-2.352-1.33-3.42 0-.54.076-1.05.199-1.48.11-.385.3-.86.63-1.19l7.5-7.5.009-.01 2.695-2.696-.204-.204-.077-.085a1.126 1.126 0 0 1 .077-1.505M13.09 7.5l.705.705.077.085a1.125 1.125 0 0 1-1.582 1.583l-.086-.078-.705-.704L10.09 10.5l.705.705.077.085a1.125 1.125 0 0 1-1.582 1.583l-.086-.077-.705-.705L7.09 13.5l.705.705.077.085a1.125 1.125 0 0 1-1.582 1.583l-.086-.077-.705-.705-.67.668c.018-.02-.032.044-.091.253a3.2 3.2 0 0 0-.113.863c0 .682.196 1.356.67 1.83.475.475 1.148.67 1.83.67.335 0 .638-.048.863-.112.152-.044.227-.082.25-.093L18.408 9l-3.41-3.41z"
      />
    </svg>
  );
}
